import { createSelector } from 'reselect';
import { constants } from './constants';

const getState = (state, query) => ({ flags: state.clientConfig, query });

const getClientConfig = createSelector(getState, ({ flags = {}, query }) => {
  if (!query) return flags;
  const keys = Object.keys(flags).filter((key) => key.includes(query));
  const clientConfig = keys.reduce((acc, key) => ({ ...acc, [key]: flags[key] }), {});
  return clientConfig;
});

const getSpecificClientConfig = createSelector(getState, ({ flags = {}, query }) => {
  if (!query) return false;
  const keys = Object.keys(flags).filter((key) => key.includes(query));
  const clientConfig = keys.reduce((acc, key) => ({ ...acc, [key]: flags[key] }), {});

  if (Object.keys(clientConfig).length === 1) return clientConfig[Object.keys(clientConfig)[0]];
  return false;
});

export { getClientConfig, getSpecificClientConfig, constants };
